// Resolve a backend asset path to a fully qualified URL.
// Mirrors the helper in the Next.js site so paths returned by the
// API render correctly regardless of where the admin is hosted.
//
//   https://…     → returned as-is
//   /storage/…    → backend (admin-uploaded files served by Laravel)
//   any other /…  → admin origin (committed static files)
//   bare name     → defaults to backend /storage/<name>

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  (process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '')
    : 'http://localhost:8000');

export default function assetUrl(path) {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  if (path.startsWith('/storage/')) return BACKEND_URL + path;
  if (path.startsWith('/')) return path;
  return `${BACKEND_URL}/storage/${path}`;
}

export { BACKEND_URL };
